window.addEventListener('DOMContentLoaded', () => {
  const regionBtn = document.querySelector('.region__name');
  if (!regionBtn) {
    return;
  }
  const navRegionBtn = document.querySelector('.nav-region__btn--burger');
  const closeBurgerMenuBtn = document.querySelector('.nav__button');
  const navRegionClose = document.querySelector('.nav-region__close');
  const regionList = document.querySelector('.region__container');
  const regionContainer = document.querySelector('.region');

  navRegionBtn.addEventListener('click', () => {
    closeBurgerMenuBtn.style.display = 'none';
  });

  navRegionClose.addEventListener('click', () => {
    closeBurgerMenuBtn.style.display = 'flex';
  });

  regionBtn.addEventListener('click', () => {
    if (!regionList.classList.contains('overlay-visible')) {
      openRegions();
    }
    else {
      closeRegions();
    }
  });


  const openRegions = () => {
    regionList.classList.add('overlay-visible', 'active');
    regionContainer.classList.add('region--open');
    document.body.addEventListener('click', onClickOutsideRegions);

  };

  const closeRegions = () => {
    regionList.classList.remove('overlay-visible', 'active');
    regionContainer.classList.remove('region--open');
    document.body.removeEventListener('click', onClickOutsideRegions);
  };

  const onClickOutsideRegions = (e) => {
    if (!e.target.closest('.region')) {
      closeRegions();
    }
  };
});
